import Dompurify from 'dompurify';

import theme from '@styles/theme';

import { FlexBox, EditorContents } from '@components/styled/StyledComponents';
import StyledModal from '@components/styled/StyledModal';
import StyledButton from '@components/styled/StyledButton';

const WelcomeModal = ({ isOpen, setIsOpen, data }: any) => {
    return (
        <StyledModal
            title="헬로미디어 가입을 환영합니다."
            isOpen={isOpen}
            closeBtnHandler={() => setIsOpen(false)}
            width="630px"
            fontSize={20}
            CLOSE={false}
            LOCK_BG
        >
            <EditorContents
                dangerouslySetInnerHTML={{
                    __html: Dompurify.sanitize(data || '')
                }}
            />
            <FlexBox $justifyContent="flex-end" $margin="40px 0 0">
                <StyledButton
                    title="확인"
                    width={142}
                    fontColor={theme.colors.blackColor}
                    bgColor={theme.colors.whiteColor}
                    border={`${theme.colors.ultraLightGrayBorder} 1px solid`}
                    onClick={() => setIsOpen(false)}
                />
            </FlexBox>
        </StyledModal>
    );
};

export default WelcomeModal;
